import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer1 from "../components/Footer1";
import axios from "axios";
import "./ArtistDashboard.css"; // We will create this next
import { useNavigate } from "react-router-dom";

const ArtistDashboard = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  // Modal State
  const [showShipModal, setShowShipModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const navigate = useNavigate();

  // Form State
  const [shippingDetails, setShippingDetails] = useState({
    courier: "BlueDart",
    trackingNumber: "",
    trackingUrl: "",
    estimatedDelivery: ""
  });

  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetchAllOrders();
  }, []);

  const fetchAllOrders = async () => {
    try {
      const res = await axios.get("http://localhost:8080/api/orders/admin/all", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrders(res.data);
    } catch (err) {
      console.error("Error fetching orders:", err);
      alert("Failed to load orders. Are you an Admin?");
       navigate("/") 
    } finally {
      setLoading(false);
    }
  };

  // Helper to auto-generate URL based on courier
  const handleTrackingChange = (e) => {
    const { name, value } = e.target;
    let updatedDetails = { ...shippingDetails, [name]: value };

    // Auto-generate URL logic
    if (name === "trackingNumber" || name === "courier") {
      const num = name === "trackingNumber" ? value : shippingDetails.trackingNumber;
      const cour = name === "courier" ? value : shippingDetails.courier;

      let url = "";
      if (cour === "BlueDart") url = `https://www.bluedart.com/track?handler=trakment&loginid=BD&awb=awb&numbers=${num}`;
      else if (cour === "DTDC") url = `https://www.dtdc.in/tracking/shipment-tracking.asp?tno=${num}`;
      else if (cour === "India Post") url = `https://www.indiapost.gov.in/_layouts/15/dop.portal.tracking/trackconsignment.aspx`;
      else if (cour === "Delhivery") url = `https://www.delhivery.com/track/package/${num}`;
      
      updatedDetails.trackingUrl = url;
    }

    setShippingDetails(updatedDetails);
  };

  const openShipModal = (order) => {
    setSelectedOrder(order);
    setShippingDetails({
      courier: "BlueDart",
      trackingNumber: "",
      trackingUrl: "",
      estimatedDelivery: ""
    });
    setShowShipModal(true);
  };

  const handleShipSubmit = async () => {
    if(!shippingDetails.trackingNumber || !shippingDetails.estimatedDelivery) {
        alert("Please fill Tracking Number and Estimate Date");
        return;
    }

    try {
      await axios.put(
        `http://localhost:8080/api/orders/${selectedOrder.id}/ship`,
        shippingDetails,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Order Marked as Shipped! 🚚");
      setShowShipModal(false);
      fetchAllOrders(); // Refresh list
    } catch (err) {
      console.error("Error updating status:", err);
      alert("Failed to update status.");
    }
  };

  // Status Color Helper
  const getStatusColor = (status) => {
    switch(status) {
        case "PAID": return "green";
        case "SHIPPED": return "orange";
        case "DELIVERED": return "blue";
        case "PENDING": return "red";
        default: return "grey";
    }
  };

  if (loading) return <div className="loading-div">Loading Admin Dashboard...</div>;

  return (
    <>
      {/* <Navbar /> */}
      <div className="admin-container">
        <h1 className="admin-title">Artist Dashboard</h1>
        <p className="admin-subtitle">Manage Orders & Shipments</p>

        <div className="orders-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Items</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id}>
                  <td>#{order.orderNumber || order.id}</td>
                  <td>
                    <div className="customer-info">
                        <strong>{order.shippingAddress?.fullName || "Unknown"}</strong>
                        <span>{order.shippingAddress?.city}</span>
                    </div>
                  </td>
                  <td>
                    {order.items.map(i => (
                        <div key={i.id} className="item-micro-row">
                            • {i.title}
                        </div>
                    ))}
                  </td>
                  <td>₹ {order.totalAmount?.toLocaleString("en-IN")}</td>
                  <td>
                    <span className="status-badge" style={{backgroundColor: getStatusColor(order.status)}}>
                        {order.status}
                    </span>
                  </td>
                  <td>
                    {order.status === "PAID" || order.status === "PLACED" ? (
                        <button className="btn-ship" onClick={() => openShipModal(order)}>
                            Ship Item
                        </button>
                    ) : (
                        <span className="text-muted">-</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 🚚 SHIPPING MODAL */}
      {showShipModal && (
        <div className="modal-overlay">
          <div className="modal-content-admin">
            <h2>Ship Order #{selectedOrder.id}</h2>
            <p>Enter details from the courier receipt.</p>

            <div className="form-group">
                <label>Courier Service</label>
                <select name="courier" value={shippingDetails.courier} onChange={handleTrackingChange}>
                    <option value="BlueDart">BlueDart</option>
                    <option value="DTDC">DTDC</option>
                    <option value="Delhivery">Delhivery</option>
                    <option value="India Post">India Post</option>
                    <option value="Other">Other</option>
                </select>
            </div>

            <div className="form-group">
                <label>Tracking Number (AWB)</label>
                <input 
                    type="text" 
                    name="trackingNumber" 
                    placeholder="e.g. 123456789" 
                    value={shippingDetails.trackingNumber}
                    onChange={handleTrackingChange}
                />
            </div>

            <div className="form-group">
                <label>Tracking URL (Auto-generated)</label>
                <input 
                    type="text" 
                    name="trackingUrl" 
                    value={shippingDetails.trackingUrl}
                    onChange={(e) => setShippingDetails({...shippingDetails, trackingUrl: e.target.value})}
                />
            </div>

            <div className="form-group">
                <label>Estimated Delivery Date</label>
                <input 
                    type="date" 
                    name="estimatedDelivery" 
                    value={shippingDetails.estimatedDelivery}
                    onChange={(e) => setShippingDetails({...shippingDetails, estimatedDelivery: e.target.value})}
                />
            </div>

            <div className="modal-actions">
                <button className="btn-confirm" onClick={handleShipSubmit}>Confirm Shipment</button>
                <button className="btn-cancel" onClick={() => setShowShipModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <Footer1 />
    </>
  );
};

export default ArtistDashboard;